import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const confirmTimeReportSummary = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        confirmTimeReportSummaryResponseModalData: {
            head: null,
            textInfo: null,
            isShow: false,
        }
    },
    mutations: {
        DATA_SAVE_REQUEST(state, value) {
            state.dataSaveIsFetching = value;
        },
        DATA_SAVE_SUCCESS(state, response) {
            state.dataSaveIsFetching = false;           
            state.confirmTimeReportSummaryResponseModalData.head = response.data.message;
            state.confirmTimeReportSummaryResponseModalData.textInfo = response.data.data.textInfo;
            state.confirmTimeReportSummaryResponseModalData.isShow = true;
            eventBus.$emit('confirmTimeReportSummarySuccess');
        },
        DATA_SAVE_FAILURE(state, error) {
            state.dataSaveIsFetching = false;
            state.confirmTimeReportSummaryResponseModalData.head = error.response.data.message;
            state.confirmTimeReportSummaryResponseModalData.textInfo = handleError(error) ;
            state.confirmTimeReportSummaryResponseModalData.isShow = true;
            console.log(error);     
        },
        UPDATE_VISIBLE_CONFIRM_TIME_REPORT_SUMMARY_RESPONSE_MODAL(state, value) {
            state.confirmTimeReportSummaryResponseModalData.isShow = value;
        }
    },
    actions: {
        confirmTimeReportSummaryRequest: function({ dispatch }, payload) {
            dispatch("requestDataSave", true);
            let promise = sendRequest("post", config.baseURLApi + "/timereports/" + payload.timeReportId + '/confirmTimeReportSummary', {}, payload);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
            });
        },
        updateVisibleConfirmTimeReportSummaryResponseModal({ commit }, value) {
            commit("UPDATE_VISIBLE_CONFIRM_TIME_REPORT_SUMMARY_RESPONSE_MODAL", value);
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        requestDataSave: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },  
    }
}

export default confirmTimeReportSummary;